import script from './component-lib.esm5.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Item', _vm._g(_vm._b({
    staticClass: "v-item-accordion",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var disabled = ref.disabled;
        return [_c('ListItemAction', {
          staticClass: "v-item-accordion__check",
          staticStyle: {
            "margin-left": "0"
          },
          on: {
            "click": _vm.handleClick
          }
        }, [_c('Checkbox', {
          attrs: {
            "id": _vm.inputId,
            "disabled": disabled,
            "input-value": _vm.isActive
          }
        })], 1), _vm._v(" "), _c('ListItemTitle', {
          staticClass: "v-item-accordion__title",
          attrs: {
            "component": "label",
            "for": _vm.inputId
          },
          on: {
            "click": _vm.handleClick
          }
        }, [_vm._t("default")], 2), _vm._v(" "), _c('FlexSpacer'), _vm._v(" "), _vm.isActive && !disabled ? _c('ListItemAction', {
          staticClass: "v-item-accordion__action",
          attrs: {
            "component": "button",
            "type": "button"
          },
          on: {
            "click": function ($event) {
              _vm.isOpen = !_vm.isOpen;
            }
          }
        }, [_vm._t("action"), _vm._v(" "), _c('ChevronIcon', {
          staticClass: "v-item-accordion__action__icon",
          attrs: {
            "direction": _vm.isOpen ? 'up' : 'down'
          }
        })], 2) : _vm._e()];
      }
    }], null, true)
  }, 'Item', Object.assign({}, _vm.$props, _vm.$attrs), false), _vm.$listeners), [_vm._v(" "), _vm.isOpen ? _c('div', {
    staticClass: "v-item-accordion__content",
    attrs: {
      "slot": "after"
    },
    slot: "after"
  }, [_c('Divider', {
    attrs: {
      "thickness": 1,
      "color": "gray300"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-item-accordion__content__inner"
  }, [_vm._t("content")], 2)], 1) : _vm._e()]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-513765b4_0", {
    source: ".v-item-accordion label[data-v-513765b4]{cursor:pointer}.v-item-accordion__content[data-v-513765b4]{padding:0 1rem .75rem}.v-item-accordion__content__inner[data-v-513765b4]{padding-top:.75rem}.v-item-accordion__action[data-v-513765b4]{background:0 0;border:none;padding:0;white-space:nowrap;font-weight:500;display:flex;align-items:center;gap:.5rem;flex-shrink:0}.v-item-accordion__action__icon[data-v-513765b4]{font-size:1.25em}.v-item-accordion__check.v-item-accordion__check[data-v-513765b4]{margin-right:0}.v-item-accordion__title.v-item-accordion__title[data-v-513765b4]{flex-grow:unset;flex-basis:auto;padding-left:2rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-513765b4";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };